import { Box, Button, Typography } from "@mui/material";
import { createFileRoute, useRouteContext } from "@tanstack/react-router";
import { ErrorBoundary } from "react-error-boundary";
import * as v from "valibot";
import { AdDetailPreview } from "../ui/components/pages/AdDetailPreview.tsx";
import SzBackdrop from "../ui/components/UISharedConstructors/Loading/SzBackDrop.tsx";
import iframeGoHome from "../utills/iframeGoHome.tsx";

const SearchSchema = v.object({
  id: v.number(),
});

export const Route = createFileRoute("/inzerat")({
  beforeLoad: ({ search }) => {
    if (search === undefined) {
      return {
        id: undefined,
      };
    }
    const validation = v.safeParse(SearchSchema, search);
    if (validation.success) {
      const result = validation.output;
      return {
        id: Number(result.id),
      };
    }

    iframeGoHome();
    return {
      id: undefined,
    };
  },
  pendingComponent: () => (
    <Box height="30em">
      <SzBackdrop />
    </Box>
  ),
  component: RouteComponent,
});

function RouteComponent() {
  const context = useRouteContext({ from: "/inzerat" });

  const id = context.id;

  if (!id) {
    iframeGoHome();
    return null;
  }

  return (
    <ErrorBoundary
      fallbackRender={() => (
        <Box
          height="20em"
          width="100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap="1em"
        >
          <Typography color="textSecondary" textAlign="center" variant="h1">
            Moc se omlouváme,
          </Typography>
          <Typography color="textSecondary" textAlign="center" variant="h3">
            ale inzerát s id{" "}
            <Box
              component="span"
              sx={(theme) => ({
                fontWeight: "bolder",
                color: theme?.vars?.palette.grey[500],
              })}
            >
              {id}
            </Box>{" "}
            bohužel neexistuje.
          </Typography>
          <Button variant="contained" color="secondary" onClick={iframeGoHome}>
            zkusit štěstí a najít jinou nabídku
          </Button>
        </Box>
      )}
    >
      <AdDetailPreview id={id} />
    </ErrorBoundary>
  );
}
